import classNames from 'classnames';
import { forwardRef, useCallback } from 'react';
import { useSetOpenedPopupsState } from '@/shared/atoms/opened-popups';
import ConfiguratorForm from '@/shared/components/configurator/Configurator/ConfiguratorForm';
import Popup from '@/shared/components/shared/Popup';

type Props = React.HTMLAttributes<HTMLElement> & {};

export const FORM_POPUP_NAME = 'constructor-form-popup';

const FormPopup = forwardRef<HTMLDivElement, Props>(({ ...props }, ref) => {
    const { closePopup } = useSetOpenedPopupsState();

    const onClick = useCallback(() => {
        closePopup(FORM_POPUP_NAME);
    }, [closePopup]);

    return (
        <Popup
            {...props}
            name={FORM_POPUP_NAME}
            ref={ref}
            className={classNames('constructor-form-popup', props.className)}
        >
            <ConfiguratorForm onClick={onClick} fromConfigurator={false} />
        </Popup>
    );
});

FormPopup.displayName = 'FormPopup';

export default FormPopup;
